import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import type { MenstrualCycleEntryRecord } from '../types/menstrualCycle';

export async function listMenstrualCycleEntries(userId: string) {
  const snapshot = await getDocs(
    query(collection(db, 'users', userId, 'menstrual_cycles'), orderBy('periodStartDate', 'desc')),
  );

  return snapshot.docs.map((document) => ({
    id: document.id,
    ...document.data(),
  })) as MenstrualCycleEntryRecord[];
}

export async function createMenstrualCycleEntry(
  userId: string,
  input: Pick<MenstrualCycleEntryRecord, 'periodStartDate' | 'periodEndDate' | 'symptoms'>,
) {
  const created = await addDoc(collection(db, 'users', userId, 'menstrual_cycles'), {
    userId,
    periodStartDate: input.periodStartDate,
    periodEndDate: input.periodEndDate,
    symptoms: input.symptoms?.trim() || '',
    sourceType: 'member_manual',
    sourceSystem: 'member_app',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return created.id;
}

export async function deleteMenstrualCycleEntry(userId: string, entryId: string) {
  await deleteDoc(doc(db, 'users', userId, 'menstrual_cycles', entryId));
}
